import React, { ReactNode } from 'react'
import { Container, Content } from './styled'

interface IProps {
  shadow: boolean
  padding: string
  children: ReactNode
}

const Wrapper = ({ shadow, padding, children }: IProps) => {
  return (
    <Container id='lmsPage' padding={padding}>
      <Content shadow={shadow}>{children}</Content>
    </Container>
  )
}

export default Wrapper
